<script lang="js">
import TablesExtend from './Tables.vue'
import ViewHeaderBar from '@/components/ViewHeaderBar.vue'

export default {
  name: 'LookupTable',

  extends: TablesExtend,

  components: {
    ViewHeaderBar,
  },

  data() {
    return {
      createTableBtnText: 'tables.createLookupTable',
      kind: 'lookup',
    }
  },

  methods: {
     // create | edit | view table page
    goToDetailPage(oper, name) {
      const tableName = name || 0
      this.$router.push({
        name: 'lookupTableDetails',
        params: {
          tableName,
        },
        query: {
          oper,
        },
      })
    },
  },
}
</script>

<style lang="scss"></style>
